import { render, staticRenderFns } from "./ChampionshipMembers.vue?vue&type=template&id=2ae66536&scoped=true"
import script from "./ChampionshipMembers.vue?vue&type=script&lang=js"
export * from "./ChampionshipMembers.vue?vue&type=script&lang=js"
import style0 from "./ChampionshipMembers.vue?vue&type=style&index=0&id=2ae66536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae66536",
  null
  
)

export default component.exports